import { APIEndpoints } from "../../constants";
import {
  APIPost,
  APIPostFormData,
  getAuthHeaders,
  getAuthFormDataHeaders,
  APIResponse,
} from "../api/common.service";
import {
  ArtworkSubmission,
  SubmitArtworkRequest,
  AssignmentCOQLResponseData,
  EditAssignmentRequest,
  EditAssignmentResponseData,
  AssignmentRecord,
} from "../../types";
import { buildWorkdriveFormData } from "../../utils/workdrive.utils";

export function SubmitArtwork(
  req: SubmitArtworkRequest,
): Promise<APIResponse<ArtworkSubmission>> {
  const formData = buildWorkdriveFormData(
    "Assignments",
    {
      Name: req.assignment_name,
      Teacher: req.teacher_id,
    },
    undefined,
    req.files,
  );

  return getAuthFormDataHeaders().then((headers) =>
    APIPostFormData<ArtworkSubmission>(
      APIEndpoints.SubmitArtwork,
      headers,
      formData,
    ),
  );
}

export function SearchTeacherAssignments(
  selectQuery: string,
): Promise<APIResponse<AssignmentCOQLResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<AssignmentCOQLResponseData>(
      APIEndpoints.GetTeacherSubmittedArtworks,
      headers,
      undefined,
      { selectQuery },
    ),
  );
}

export function EditAssignment(
  body: EditAssignmentRequest,
): Promise<APIResponse<EditAssignmentResponseData>> {
  return getAuthHeaders().then((headers) =>
    APIPost<EditAssignmentResponseData>(
      APIEndpoints.MarkArtwork,
      headers,
      undefined,
      body as unknown as Record<string, unknown>,
    )
  );
}
